export const SERVICE_CODE = 'TRAINING_ATTACHMENT' + '_SERVICE';
